<template>
  <div class="page-header">
    <!-- <a-breadcrumb class="breadcrumb">
      <a-breadcrumb-item v-if="breadList[0] && breadList[0].path !== '/'">
        <router-link
          :to="{ path: '/' }"
        >首页</router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item v-for="(item, index) in breadList" :key="item.name">
        <router-link
          v-if="item.path && item.name != name && index != 1"
          :to="{ path: item.path === '' ? '/' : item.path }"
        >{{ item.title }}</router-link>
        <span v-else>{{ item.title }}</span>
      </a-breadcrumb-item>
    </a-breadcrumb> -->
    <div class="detail">
      <div class="main">
        <div class="row">
          <h1 class="title">{{ name }}</h1>
          <div class="action"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menus from '@/core/menus'
export default {
  data () {
    return {
      name: '',
      breadList: []
    }
  },
  created () {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb () {
      this.breadList = []
      this.name = ''
      let menu = this.findMenu(menus, this.$route.path)
      if (menu) {
        this.name = menu[menu.length - 1].title
        this.breadList = menu
      }
    },
    findMenu (menus, path) {
      let rt
      menus.find(menu => {
        if (menu.path === path) {
          rt = [menu]
          return true
        }
        if (menu.children) {
          let childMenu = this.findMenu(menu.children, path)
          if (childMenu) {
            rt = [menu, ...childMenu]
            return true
          }
        }
        return false
      })
      return rt
    }
  },
  watch: {
    $route () {
      this.getBreadcrumb()
    }
  }
}
</script>

<style scoped>
.page-header{
  /* margin: -24px -48px 24px -24px; */
  background: #fff;
  padding: 16px 32px 0;
  border-bottom: 1px solid #e8e8e8;
  margin: -24px -24px 24px -24px;

}
.breadcrumb{
  margin-bottom: 16px;
}
.page-header .detail .main .title{
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
    color: rgba(0,0,0,.85);
    margin-bottom: 16px;
    -webkit-box-flex: 1;
    -ms-flex: auto;
    flex: auto;
}
</style>
